import Avatar from '@mui/material/Avatar';
import { cyan, purple } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para modalidades de sessão julgamento.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const MODALIDADE_SESSAO_JULGAMENTO = {
    PRESENCIAL     : { id: 'PRESENCIAL',     descricao: 'Presencial',     codigo: 'P', cor: cyan[800]   },
    TELEPRESENCIAL : { id: 'TELEPRESENCIAL', descricao: 'Telepresencial', codigo: 'T', cor: purple[800] },
    HIBRIDA        : { id: 'HIBRIDA',        descricao: 'Híbrida',        codigo: 'H', cor: cyan[800]   }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de modalidades de sessão julgamento.
 * @readonly
 */
export default class ModalidadeSessaoJulgamento {
    static situacaoBase = new SituacaoIdDescricaoBase(MODALIDADE_SESSAO_JULGAMENTO);
    static MSG_ERRO_IDENTIFICACAO_MODALIDADE_SESSAO_JULGAMENTO =
        'Não foi possível identificar a modalidade de julgamento.';

    static getDescricao(id) {
        return ModalidadeSessaoJulgamento.situacaoBase.getDescricao(id);
    }

    static getCodigo(id) {
        return ModalidadeSessaoJulgamento.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getCor(id) {
        return ModalidadeSessaoJulgamento.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getIcone(id) {
        const tamanhoIcone = '26px';
        const obj = ModalidadeSessaoJulgamento.situacaoBase.getObjectById(id);

        return (
            <Avatar
                style={{
                    width: tamanhoIcone,
                    height: tamanhoIcone,
                    fontWeight: '600',
                    fontSize: '0.96rem',
                    backgroundColor: obj.cor
                }}
            >
                {obj.codigo}
            </Avatar>
        );
    }
}
